module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile-overview"
  }, [(_vm.user.avatar) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.user.avatar
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.user.avatar) ? _c('i', {
    staticClass: "avatar fa fa-user",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.vehicle.avatar) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.vehicle.avatar
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.vehicle.avatar) ? _c('i', {
    staticClass: "avatar fa fa-motorcycle",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("\n    " + _vm._s(_vm.user.name) + " "), _c('br'), _vm._v("\n    " + _vm._s(_vm.vehicle.name) + "\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('br'), _vm._v("\n    " + _vm._s(_vm.vehicle.brand) + " " + _vm._s(_vm.vehicle.model) + "\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1aff54c2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProfileOverview.vue
// module id = 199
// module chunks = 1